<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-center">
          <div class="card-custom-web">
            <br />
            <div class="text-left ml-4 mr-3">
              <div v-for="item in detail.slice(0, 1)" v-bind:key="item.id">
                <h4 class="custom-user-title">
                  {{ item.dataMessage }}
                </h4>
                <h5 class="custom-user-subtitle">
                  <span v-html="item.description.replace(/\n/g, '<br>')"></span>
                </h5>
                <br />
                <div v-if="item.notiUser === 1">
                  <div v-if="item.description == 'A student offer a tutor job for you'">
                  <CButton
                    type="button"
                    color="success"
                    @click="OpenDetail(item.findTutorId)"
                    >View</CButton
                  >
                </div>

                  <div v-if="DetailClass == true">
                    <div v-for="item in incoming" v-bind:key="item.id">
                      <div v-if="item.findTutorId == ftId">
                        <br />
                        <CCard
                          style="
                            position: fixed;
                            bottom: 0px;
                            margin: 0 auto;
                            left: 0;
                            right: 0;
                            width: -webkit-fill-available;
                            height: 400px;
                          "
                          class="container"
                        >
                          <CRow class="mt-3">
                            <span style="width: 85%" class="float-left">
                              <h6 class="text-center">
                                <strong>{{ item.subjectName }}</strong>
                              </h6>
                            </span>

                            <span
                              style="width: 15%"
                              class="float-right"
                              @click="CloseDetail"
                              ><h6><strong>X</strong></h6></span
                            >
                          </CRow>
                          <h6 class="ml-3"><strong>Class Details</strong></h6>
                          <img
                            style="width: 50px; height: 50px; object-fit: cover"
                            src="../assets/img/icon/icondefault.svg"
                            class="ml-3"
                          />
                          <br />
                          <CRow class="ml-2 mr-2">
                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Student</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.studentName }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Grade</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.level }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Subject</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.subjectName }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <!-- <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Parent Name</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.parentName }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Contact No.</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.parentPhone }}
                            </div>
                            <div style="clear: both"></div>

                            <br /> -->

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Date</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.day }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Time</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.hour }}
                            </div>
                            <div style="clear: both"></div>
                            <!-- {{ item.findTutorId }} -->

                            <br />

                            <div style="clear: both"></div>

                            <br />
                          </CRow>

                          <CRow class="justify-content-center">
                            <CCol
                              style="
                                display: flex;
                                align-items: center;
                                justify-content: center;
                              "
                            >
                              <CCol sm="12" lg="12">
                                <CCol
                                  sm="12"
                                  lg="12"
                                  style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    left: 0;
                                    right: 0;
                                    bottom: 0px;
                                  "
                                >
                                  <CCol
                                    sm="4"
                                    lg="4"
                                    class="p-0 mr-2"
                                    style="width: 25%"
                                  >
                                  </CCol>

                                  <CCol
                                    sm="4"
                                    lg="4"
                                    class="p-0 mr-2"
                                    style="width: 25%"
                                  >
                                    <CCard
                                      style="border: none"
                                      class="text-center p-1"
                                    >
                                      <CCol>
                                        <img
                                          src="../assets/img/icon/reject.svg"
                                          @click="RejectJob = true"
                                        />
                                        <br />
                                        <label
                                          class="text-icon custom-font-card"
                                        >
                                          Reject</label
                                        >
                                      </CCol>
                                    </CCard>
                                  </CCol>

                                  <CCol
                                    sm="4"
                                    lg="4"
                                    class="p-0 mr-2"
                                    style="width: 25%"
                                  >
                                    <CCard
                                      style="border: none"
                                      class="text-center p-1"
                                      @click="OpenAccept(item.findTutorId)"
                                    >
                                      <CCol>
                                        <img
                                          src="../assets/img/icon/accept.svg"
                                        />
                                        <br />
                                        <label
                                          class="text-icon custom-font-card"
                                        >
                                          Apply
                                        </label>
                                      </CCol>
                                    </CCard>
                                  </CCol>
                                </CCol>
                              </CCol>
                            </CCol>
                          </CRow>
                          <br />
                        </CCard>
                      </div>
                    </div>
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div v-if="item.notiUser === 2">
                  <CButton
                    type="button"
                    color="success"
                    @click="GoToPageAccept(item.teacherId)"
                    >View</CButton
                  >
                </div>

                <div v-if="item.notiUser === 3">
                  <CButton
                    type="button"
                    color="success"
                    @click="OpenDetailResponse(item.findTutorId)"
                    >View</CButton
                  >

                  <div v-if="DetailClassRespond == true">
                    <div v-for="item in confirm" v-bind:key="item.id">
                      <div v-if="item.findTutorId == ftId">
                        <CCard
                          style="
                            position: fixed;
                            bottom: 0px;
                            margin: 0 auto;
                            left: 0;
                            right: 0;
                            width: -webkit-fill-available;
                            height: 400px;
                          "
                          class="container"
                        >
                          <CRow class="mt-3">
                            <span style="width: 85%" class="float-left">
                              <h6 class="text-center">
                                <strong>{{ item.subjectName }}</strong>
                              </h6>
                            </span>

                            <span
                              style="width: 15%"
                              class="float-right"
                              @click="CloseDetailRespond"
                              ><h6><strong>X</strong></h6></span
                            >
                          </CRow>
                          <h6 class="ml-3"><strong>Class Details</strong></h6>
                          <img
                            style="width: 50px; height: 50px; object-fit: cover"
                            class="ml-3"
                            src="../assets/img/icon/icondefault.svg"
                          />
                          <br />
                          <CRow class="ml-2 mr-2">
                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Student</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.studentName }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Grade</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.level }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Subject</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.subjectName }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Parent Name</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.parentName }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Contact No.</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.parentPhone }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Date</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.day }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="width: 25%" class="float-left">
                              <h6 class="ml-2"><strong>Time</strong></h6>
                            </div>
                            <div style="width: 75%" class="float-right">
                              : {{ item.hour }}
                            </div>
                            <div style="clear: both"></div>

                            <br />

                            <div style="clear: both"></div>

                            <br />
                          </CRow>
                          <CRow class="justify-content-center mt-3">
                            <CCol
                              style="
                                display: flex;
                                align-items: center;
                                justify-content: center;
                              "
                            >
                              <CCol sm="12" lg="12">
                                <CCol
                                  sm="12"
                                  lg="12"
                                  style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    left: 0;
                                    right: 0;
                                    bottom: 0px;
                                  "
                                >
                                  <CCol
                                    sm="3"
                                    lg="3"
                                    class="p-0 mr-2"
                                    style="width: 25%"
                                  >
                                    <CCard
                                      style="border: none"
                                      class="text-center p-1"
                                      @click="OpenReschedule(item.findTutorId)"
                                    >
                                      <CCol>
                                        <img
                                          src="../assets/img/icon/reschedule.svg"
                                        />
                                        <br />
                                        <label
                                          class="text-icon custom-font-card"
                                        >
                                          Schedule
                                        </label>
                                      </CCol>
                                    </CCard>
                                  </CCol>

                                  <CCol
                                    sm="3"
                                    lg="3"
                                    class="p-0 mr-2"
                                    style="width: 25%"
                                  >
                                    <CCard
                                      style="border: none"
                                      class="text-center p-1"
                                    >
                                      <CCol>
                                        <img
                                          src="../assets/img/icon/classAttendance.svg"
                                          style="filter: grayscale(1)"
                                        />
                                        <br />
                                        <label
                                          class="text-icon custom-font-card"
                                          @click="GoToAttendance()"
                                        >
                                          Attendance</label
                                        >
                                      </CCol>
                                    </CCard>
                                  </CCol>

                                  <CCol
                                    sm="3"
                                    lg="3"
                                    class="p-0 mr-2"
                                    style="width: 25%"
                                  >
                                    <CCard
                                      style="border: none"
                                      class="text-center p-1"
                                    >
                                      <CCol>
                                        <img
                                          src="../assets/img/icon/iconQuizWarning.svg"
                                          style="filter: grayscale(1)"
                                        />
                                        <br />
                                        <label
                                          class="text-icon custom-font-card"
                                        >
                                          Quiz</label
                                        >
                                      </CCol>
                                    </CCard>
                                  </CCol>

                                  <CCol
                                    sm="3"
                                    lg="3"
                                    class="p-0 mr-2"
                                    style="width: 25%"
                                  >
                                    <CCard
                                      style="border: none"
                                      class="text-center p-1"
                                    >
                                      <CCol>
                                        <img
                                          src="../assets/img/icon/classChat.svg"
                                          style="filter: grayscale(1)"
                                        />
                                        <br />
                                        <label
                                          class="text-icon custom-font-card"
                                        >
                                          Chat</label
                                        >
                                      </CCol>
                                    </CCard>
                                  </CCol>
                                </CCol>
                              </CCol>
                            </CCol>
                          </CRow>
                        </CCard>
                      </div>
                    </div>
                  </div>

                  <div v-if="SelectDay == true">
                    <div v-for="item in confirm" v-bind:key="item.id">
                      <div v-if="item.findTutorId == ftId">
                        <br />
                        <CCard
                          style="
                            position: fixed;
                            bottom: 0px;
                            margin: 0 auto;
                            left: 0;
                            right: 0;
                            width: -webkit-fill-available;
                            height: auto;
                          "
                          class="container"
                        >
                          <span
                            class="float-right text-right m-2"
                            @click="CloseDetailSchedule"
                          >
                            <h6><strong>X</strong></h6>
                          </span>
                          <h6 class="text-center mt-3">
                            <strong>Your Available Time</strong>
                          </h6>
                          <label class="text-center mt-3">
                            Select a date that you want to have a class with
                            {{ item.studentName }}
                          </label>
                          <div class="text-center">
                            <datepicker
                              :inline="true"
                              v-model="selectedDay"
                            ></datepicker>
                            <p>{{ selectedDay | moment("YYYY MMM DD") }}</p>
                            <CButton
                              color="info"
                              class="btn-select-blue mt-3 text-center m-0"
                              @click="
                                OpenAvailableTime(item.findTutorId, selectedDay)
                              "
                            >
                              Select Date
                            </CButton>
                          </div>
                        </CCard>
                        <div style="clear: both"></div>
                      </div>
                    </div>
                  </div>

                  <div v-if="SelectTime == true">
              <div v-for="con in confirm" v-bind:key="con.id">
                <div v-if="con.findTutorId == ftId">
                  <br />
                  <CCard
                    style="position: fixed;
                      bottom: 0px;
                      margin:0 auto;
                      left:0;
                      right:0;
                      width: -webkit-fill-available;
                      height: auto;"
                    class="container">
                    <span class="float-right text-right m-2" @click="CloseDetailTime">
                      <h6><strong>X</strong></h6>
                    </span>
                    <h6 class="text-center mt-3">
                      <strong>Tutor's Available Time</strong>
                    </h6>
                    <label class="text-center mt-3">
                      Select the available time for this tutor on {{selectedDay | moment("DD MMM YYYY - dddd")}}
                    </label>
                
                    <p class="head-time ml-4 mb-2" style="color: #B8B8B8;">Morning</p>
                    <CRow class="ml-1 mb-2">
                      <div v-for="item in hour" v-bind:key="item.id">
                        <div v-if="item.timeId == '1'">
                          <CCol style="padding-right: 5px; padding-left: 0px;">
                            <CCard class="card-time mb-1" >
                              <CButton class="time" @click="selectTime(item.name)">
                                {{ item.convertHour }} 
                              </CButton>
                            </CCard>
                          </CCol>
                        </div>
                      </div>
                    </CRow>
                
                    <p class="head-time ml-4 mb-2" style="color: #B8B8B8;">Evening</p>
                    <CRow class="ml-1 mb-2">
                      <div v-for="item in hour" v-bind:key="item.id">
                        <div v-if="item.timeId == '2'">
                          <CCol style="padding-right: 5px; padding-left: 0px;">
                            <CCard class="card-time mb-1" >
                              <CButton class="time" @click="selectTime(item.name)">
                                {{ item.convertHour }} 
                              </CButton>
                            </CCard>
                          </CCol>
                        </div>
                      </div>
                    </CRow>
                    
                    <p class="head-time ml-4 mb-2" style="color: #B8B8B8;">Night</p>
                    <CRow class="ml-1 mb-2">
                      <div v-for="item in hour" v-bind:key="item.id">
                        <div v-if="item.timeId == '3'">
                          <CCol style="padding-right: 5px; padding-left: 0px;">
                            <CCard class="card-time mb-1" >
                              <CButton class="time" @click="selectTime(item.name)">
                                {{ item.convertHour }} 
                              </CButton>
                            </CCard>
                          </CCol>
                        </div>
                      </div>
                    </CRow>

                    <p class="head-time ml-4 mb-2" style="color: #B8B8B8;">Minutes</p>
                    <input type="text" style="background: #FFFFFF; border: 1px solid #E0E0E0; border-radius: 10px; width: 10%;" v-model="minutes" />

                    <p>{{ selectedTime }} </p>

                    <CButton color="info" class="btn-select-blue mt-3 text-center m-0" @click="OpenClassLink(con.findTutorId, selectedTime, minutes)">
                      Next
                    </CButton>
                  </CCard>
                  <div style="clear:both"></div>
                </div>
              </div>
            </div>

                  <div v-if="SelectClassLink == true">
              <div v-for="con in confirm" v-bind:key="con.id">
                <div v-if="con.findTutorId == ftId">
                  <br />
                  <CCard
                    style="position: fixed;
                      bottom: 0px;
                      margin:0 auto;
                      left:0;
                      right:0;
                      width: -webkit-fill-available;
                      height: auto;"
                    class="container">
                    <span class="float-right text-right m-2" @click="CloseDetailLink">
                      <h6><strong>X</strong></h6>
                    </span>
                    <h6 class="text-center mt-3">
                      <strong>Video Conference</strong>
                    </h6>
                    <label class="text-center mt-3">
                      Set Your Video Conference Link with {{ con.studentName }}
                    </label>
                
                    <p style="color: #000; text-align: left" class="mb-1">
                      Meeting ID
                    </p>
                      <input
                        type="text"
                        class="custom-input-user mb-3"
                        placeholder="Enter Meeting ID"
                        v-model="meetingId"
                      />          

                    <p style="color: #000; text-align: left" class="mb-1">
                      Meeting Password
                    </p>
                      <input
                        type="text"
                        class="custom-input-user mb-3"
                        placeholder="Enter Meeting Password"
                        v-model="meetingPassword"
                      />

                    <p style="color: #000; text-align: left" class="mb-1">
                      Video Conference Link
                    </p>
                      <input
                        type="text"
                        class="custom-input-user mb-3"
                        placeholder="Enter Conference Link"
                        v-model="classLink"
                      />
                    <CButton color="info" class="btn-select-blue mt-3 text-center m-0" @click="GoToSubmit(con.findTutorId, meetingId, meetingPassword,classLink)">
                      Confirm
                    </CButton>
                  </CCard>
                  <div style="clear:both"></div>
                </div>
              </div>
            </div>

            <div v-if="DetailClassConfirm == true">
              <div class="ml-3 mr-3" v-for="item in confirm" v-bind:key="item.id">
              <div v-if="item.findTutorId == ftId">
                <CCard
                    style="position: fixed;
                      bottom: 0px;
                      margin:0 auto;
                      left:0;
                      right:0;
                      width: -webkit-fill-available;
                      height: auto;"
                    class="container">
                <CRow>
                  <CCol>
                    <img src="../assets/img/icon/iconUserBlue.svg"/>
                  </CCol>
                  <CCol style="margin-left: -330px;">
                    <label class="label-blue ml-2" style="color: #007CEF;">Tutor</label> <br />
                    <label class="label-blue ml-2" style="color: ##000A2C; font-weight: 400;">{{ teaid.userName }}</label>
                  </CCol>                
                </CRow>
                <hr />

                <CRow>
                  <CCol>
                    <img src="../assets/img/icon/iconUserBlue.svg"/>
                  </CCol>
                  <CCol style="margin-left: -330px;">
                    <label class="label-blue ml-2" style="color: #007CEF;">Student</label> <br />
                    <label class="label-blue ml-2" style="color: ##000A2C; font-weight: 400;">{{ item.studentName }} </label>
                  </CCol>                
                </CRow>
                <hr />

                <CRow>
                  <CCol>
                    <img src="../assets/img/icon/iconBookBlue.svg"/>
                  </CCol>                  
                  <CCol style="margin-left: -330px;">
                    <label class="label-blue ml-2" style="color: #007CEF;">Subject</label> <br />
                    <label class="label-blue ml-2" style="color: #000A2C; font-weight: 400;">{{ item.subjectName }} </label>
                    <br />
                    <label class="label-blue ml-2" style="color: #000A2C; font-weight: 400;">{{ item.languages }} </label>
                  </CCol>               
                </CRow>
                <hr />

                <CRow>
                  <CCol>
                    <img src="../assets/img/icon/iconCalendarBlue.svg"/>
                  </CCol>                  
                  <CCol style="margin-left: -330px;">
                    <label class="label-blue ml-2" style="color: #007CEF;">Schedule</label> <br />
                    <label class="label-blue ml-2" style="color: ##000A2C; font-weight: 400;">{{ selectedDay | moment("dddd (DD-MMM-YYYY)") }} </label>
                    <br />
                    <label class="label-blue ml-2" style="color: ##000A2C; font-weight: 400;">{{ hourminute }} </label>
                    <!-- <label class="label-blue ml-2" style="color: ##000A2C; font-weight: 400;">{{ selectedTime | moment("hh:mm")}} </label> -->
                  </CCol>                
                </CRow>
                <hr />

                <CRow>
                  <CCol>
                    <img src="../assets/img/icon/iconCalendarBlue.svg"/>
                  </CCol>                  
                  <CCol style="margin-left: -330px;">
                    <label class="label-blue ml-2" style="color: #007CEF;">Video Conference</label> <br />
                    <label class="label-blue ml-2" style="color: ##000A2C; font-weight: 400;">Meeting ID : {{ meetingId }} </label>
                    <br />
                    <label class="label-blue ml-2" style="color: ##000A2C; font-weight: 400;">Meeting Password : {{ meetingPassword }} </label>
                    <br />
                    <label class="label-blue ml-2" style="color: ##000A2C; font-weight: 400;">Class Link : {{ classLink }} </label>
                  </CCol>                
                </CRow>
                
                <br /> <br /> <br />

                <input type="checkbox" />
                <label class="label-blue" style="color: #000A2C; font-weight: 400;">Set class recurring every week</label>

                <br /> <br /> <br /> <br /> <br /> <br />

                <div class="bottom-center text-center">
                  <CButton  style="
                    position: fixed;
                    bottom: 30px;
                    left: 0px;
                    right: 0px;
                    text-align: center;
                    margin: 0 auto;
                    " color="info" class="btn-select-blue mt-5" @click="SubmitSchedule(item.findTutorId)">
                   {{ buttonlabel }}
                  </CButton>

                </div>
                </CCard>
              </div>
            </div>
            </div>

           
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CContainer>

    <div style="text-transform: capitalize" class="header-top">
      {{ notiType }}
    </div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>



<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import Datepicker from "vuejs-datepicker";

import 'vue-date-pick/dist/vueDatePick.css';
import "fullcalendar/dist/fullcalendar.css";
//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import "vue-sweet-calendar/dist/SweetCalendar.css";

import moment from "moment";



import "hooper/dist/hooper.css";

export default {
  components: {
    Datepicker,
  },
  data: function () {
    return {
      detail: [],
      notiType: this.$route.query.notiType,

      DetailClass: false,
      incoming: [],
      DetailClassRespond: false,
      confirm: [],
      SelectDay: false,
      SelectTime: false,
      SelectClassLink: false,

      selectedDay: "",
      selectedTime: "",
      hours: this.hours,
      meetingId: "",
      meetingPassword: "",
      classLink: "",
      minutes: "0",
      hourminute: "",

      CloseDetailSchedule: false,

      DetailClassConfirm: false,
      buttonlabel: 'Reschedule'
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetNoti(this.user.id);
            this.GetTeacherId(this.user.id);
            this.GetListIncomingJob(this.user.id);
            this.GetListConfirmJob(this.user.id);
            this.GetHour();
          }
        });
    },
    GetTeacherId() {
      this.$API
        .get(this.$SelectTeacherId + "?userId=" + this.user.id, {})
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teaid = response.data;
            console.log("teacherid", this.teaid);
          }
        });
    },
    GetNoti() {
      return this.$API
        .get(
          this.$NotiUserDetail +
            "?id=" +
            +this.user.id +
            "&take=" +
            this.$route.query.take
        )
        .then(
          function (response) {
            this.detail = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GoBack() {
      this.$router.back();
    },
    OpenDetail(findTutorId) {
      console.log("test" + findTutorId);
      this.ftId = findTutorId;
      this.DetailClass = true;
    },
    GetListIncomingJob() {
      this.$API
        .get(this.$TutorPendingJob + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.incoming = response.data;
          }
        });
    },
    OpenAccept(ftid) {
      const formData = new FormData();

      formData.append("FindTutorId", ftid);
      formData.append("TeacherId", this.teaid.teacherId);

      return this.$API
        .post(this.$TeacherConfirmClass, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.GoToPageNotification();
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    GoToPageNotification() {
      this.$router.push("Notification");
    },
    CloseDetail() {
      this.DetailClass = false;
    },
    GoToPageAccept(teacherId) {
      this.$router.push(
        "FindTutor/MTTutorProfile?notiId=" +
          this.$route.query.take +
          "&teacherId=" +
          teacherId
      );
    },
    OpenDetailResponse(findTutorId) {
      this.ftId = findTutorId;
      this.DetailClassRespond = true;
    },
    GetListConfirmJob() {
      this.$API
        .get(this.$TutorConfirmJob + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.confirm = response.data;
          }
        });
    },
    OpenReschedule(ftId) {
      this.ftId = ftId;
      this.SelectDay = true;
      this.DetailClass = false;
    },
    CloseDetailRespond() {
      this.DetailClassRespond = false;
    },
    OpenAvailableTime(ftId) {
      this.ftId = ftId;
      this.SelectTime = true;
      this.SelectDay = false;
      this.DetailClassRespond = false;
    },
    OpenClassLink(ftId) {
      this.ftId = ftId;
      this.SelectClassLink = true;
      this.SelectTime = false;
      this.DetailClassRespond = false;
    },

    CloseDetailLink() {
      this.SelectClassLink = false;
    },
    GetHour() {
      this.$API
        .get(this.$GetHour, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.hour = response.data;
            // this.selectedTime = this.hour;

            // for (let i = 0; i < this.hour.length; i++) {
            //   const element = this.hour[i];
            //   this.hours = element.Name;
            //   console.log("testing", this.hours);

            // }
          }
        });
    },
    selectTime(name, minute){
       this.selectedTime = name;
       this.hourminute = this.selectedTime.setMinutes(this.selectedTime.getMinutes() + minutes);
      //  this.hourminute = moment(this.selectedTime).add(this.minutes, 'minutes');

      //  {{ selectedTime | moment("hh:mm:ss").add(minutes, 'minutes') }}
      //  var hourminute = new Date();

    },
    OpenClassLink(ftId) {
      this.ftId = ftId;
      this.SelectClassLink = true;
      this.SelectTime = false;
    },

    CloseDetailLink() {
      this.SelectClassLink = false;
    },
    GoToSubmit(ftId, meetingId, meetingPassword, classLink){
      this.ftId = ftId;
      this.DetailClassConfirm = true;
      this.meetingId = meetingId;
      this.meetingPassword = meetingPassword;
      this.classLink = classLink;
      this.SelectClassLink = false;
      this.SelectTime = false;
      this.SelectDay = false;
    },
    CloseDetailTime() {
      this.SelectTime = false;
    },
    SubmitSchedule(findTutorId){
      this.buttonlabel = 'Processing';
      const formData = new FormData();

      var Date = moment(this.selectedDay).format('YYYY-MM-DD');
      // var Time = moment(this.selectedTime).format('hh:mm:ss');
      
      formData.append("FindTutorId", findTutorId);
      formData.append("Dates", Date);
      formData.append("Times", this.selectedTime);
      formData.append("vcLink", this.classLink);
      formData.append("meetingId", this.meetingId);
      formData.append("password", this.meetingPassword);
      formData.append("addMinutes", this.minutes);
      

      return this.$API
        .post(this.$TeacherSetScheduleNew, formData, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.status);
          console.log(response.data);
          if(response.status == 200 && response.data != null) {
            this.Message = response.data.Message;
            this.SuccessMessage = true;
            this.GoToAllSet();
          } else {
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
        });
    },
    GoToAllSet() {
      this.$router.push("Tutor/TutorJobAccept");
    },


  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
</style>